import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { useToggle } from '@infl-ts/util-hooks';
import { createChallengePlayerLink } from '@infl-ts/util-use-challenge-player';
import { Close as CloseIcon } from '@mui/icons-material';
import { Alert, Box, Divider, IconButton, SwipeableDrawer, useMediaQuery } from '@mui/material';
import * as A from 'fp-ts/Array';
import { constNull, identity, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { Translation, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { ChallengeCard } from '../challenge-card';
import { Popover } from '../popover';
import { Tooltip } from '../tooltip';
import PopoverBody from './popover-body';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ChallengeNotAvailableAlert = function ChallengeNotAvailableAlert() {
  return /*#__PURE__*/_jsx(Alert, {
    severity: "info",
    "data-element": "Alert",
    "data-component": "ChallengeNotAvailableAlert",
    "data-source-file": "challenge-summary-popover.tsx",
    children: /*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-component": "ChallengeNotAvailableAlert",
      "data-source-file": "challenge-summary-popover.tsx",
      children: function children(t) {
        return t('The challenge for this response is no longer available.');
      }
    })
  });
};

var getFirstCompletedActivity = A.findFirst(function (activity) {
  return activity.state === 'closed';
});

var PopoverContent = function PopoverContent(_ref) {
  var response = _ref.response,
      challenge = _ref.challenge;
  var location = useLocation();
  var firstCompletedActivity = pipe(challenge.activities, O.fromNullable, O.chain(getFirstCompletedActivity), O.match(constNull, identity));
  var responseLink = pipe(firstCompletedActivity ? {
    activity: firstCompletedActivity.id,
    scrollTo: response.id
  } : {}, function (cpOptions) {
    return createChallengePlayerLink(location.pathname, _objectSpread({
      uuid: challenge.id
    }, cpOptions));
  });
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      width: 1
    },
    "data-element": "Box",
    "data-component": "PopoverContent",
    "data-source-file": "challenge-summary-popover.tsx",
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        p: 2,
        maxHeight: 300,
        overflowY: 'auto'
      },
      "data-element": "Box",
      "data-component": "PopoverContent",
      "data-source-file": "challenge-summary-popover.tsx",
      children: /*#__PURE__*/_jsx(PopoverBody, {
        response: response,
        responseLink: responseLink,
        isResponseOpenable: !!firstCompletedActivity,
        "data-element": "PopoverBody",
        "data-component": "PopoverContent",
        "data-source-file": "challenge-summary-popover.tsx"
      })
    }), /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-source-file": "challenge-summary-popover.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        m: 2,
        height: challenge.availableForCompletion ? '126px' : '100%'
      },
      "data-element": "Box",
      "data-source-file": "challenge-summary-popover.tsx",
      children: challenge.availableForCompletion ? /*#__PURE__*/_jsx(ChallengeCard, {
        challenge: challenge,
        challengeLink: createChallengePlayerLink(location.pathname, {
          uuid: challenge.id
        }),
        variant: "landscape"
      }) : /*#__PURE__*/_jsx(ChallengeNotAvailableAlert, {})
    })]
  });
};

var PopoverDrawer = function PopoverDrawer(_ref2) {
  var children = _ref2.children,
      challenge = _ref2.challenge,
      response = _ref2.response;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      open = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      hide = _useToggle2$.off,
      show = _useToggle2$.on;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        cursor: 'pointer',
        width: 1
      },
      onClick: show,
      "data-element": "Box",
      "data-component": "PopoverDrawer",
      "data-source-file": "challenge-summary-popover.tsx",
      children: typeof children === 'function' ? children({
        handleClosePopover: hide,
        isOpen: open
      }) : children
    }), /*#__PURE__*/_jsx(SwipeableDrawer, {
      open: open,
      anchor: "bottom",
      transitionDuration: 500,
      disablePortal: true,
      onClose: hide,
      onOpen: show,
      "data-element": "SwipeableDrawer",
      "data-source-file": "challenge-summary-popover.tsx",
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          height: '100vh',
          position: 'relative'
        },
        "data-element": "Box",
        "data-source-file": "challenge-summary-popover.tsx",
        children: open && /*#__PURE__*/_jsx(PopoverContent, {
          isMobile: true,
          response: response,
          challenge: challenge,
          closeButton: /*#__PURE__*/_jsx(Tooltip, {
            title: t('Close'),
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: hide,
              size: "small",
              "aria-label": "close",
              children: /*#__PURE__*/_jsx(CloseIcon, {
                sx: {
                  height: 24,
                  width: 24
                }
              })
            })
          })
        })
      })
    })]
  });
};

export var ChallengeSummaryPopover = function ChallengeSummaryPopover(_ref3) {
  var children = _ref3.children,
      challenge = _ref3.challenge,
      response = _ref3.response;
  var isDesktop = useMediaQuery(function (theme) {
    return theme.breakpoints.up('md');
  });
  var POPOVER_WIDTH = 512;
  var placeVertically = useContainerMediaQuery({
    minWidth: POPOVER_WIDTH
  });
  return isDesktop ? /*#__PURE__*/_jsx(Popover, _objectSpread(_objectSpread({
    sx: {
      maxHeight: 458,
      width: POPOVER_WIDTH,
      minWidth: {
        xs: 0,
        md: POPOVER_WIDTH
      }
    },
    containerSx: {
      width: 1
    },
    zIndex: function zIndex(t) {
      return t.zIndex.popover;
    },
    noPadding: true,
    arrow: true,
    enablePortal: true
  }, placeVertically ? {
    placement: 'bottom',
    fallbackPlacements: ['top']
  } : {
    placement: 'left',
    fallbackPlacements: ['right']
  }), {}, {
    content: function content() {
      return /*#__PURE__*/_jsx(PopoverContent, {
        response: response,
        challenge: challenge,
        isMobile: false
      });
    },
    children: children
  })) : /*#__PURE__*/_jsx(PopoverDrawer, {
    challenge: challenge,
    response: response,
    children: children
  });
};